export default "__VITE_ASSET__BchcZqju__"